import { render, staticRenderFns } from "./payment-gateway-advam.vue?vue&type=template&id=5cfe8da7&scoped=true"
import script from "./payment-gateway-advam.vue?vue&type=script&setup=true&lang=ts"
export * from "./payment-gateway-advam.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./payment-gateway-advam.vue?vue&type=style&index=0&id=5cfe8da7&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfe8da7",
  null
  
)

export default component.exports